import axios from "axios";
import { push } from "react-router-redux";

import { setLoading } from "../app/actions";
import { URLS } from "constants/urlConstants";
import generateQuery, { generateSorting } from "helpers/query";
import { getTranslation } from "helpers/common";
import IMeta from "models/IMeta";
import _ from "lodash";
import { CUSTOM_SETTINGS } from "constants/index";
import { actionTypes } from "../areaStatementView/actions";
import { areaStatementSorting } from "constants/sorting";
import {
  generateLeliePdf,
  generateVorrjPdf,
  generateZantPdf,
} from "helpers/generatePdf";
import { downloadDeliveryNote } from "helpers/download";
import { localRequest } from "../../apiUtils";

export default class Actions {
  public static getAreaStatementsList(meta: IMeta = {}) {
    return async (dispatch, getState) => {
      dispatch(request());
      dispatch(setLoading(true));

      if (_.isEmpty(meta)) {
        meta = _.get(getState(), "areaStatements.meta", {});
      }

      if (!meta.pageSize) {
        const savedSettings = JSON.parse(
          localStorage.getItem("customSettings") || "{}"
        );
        _.set(
          meta,
          "pageSize",
          _.get(savedSettings, `${CUSTOM_SETTINGS.areaStatements}.pageSize`, 10)
        );
      }
      meta.defaultSorting = areaStatementSorting;

      const url = `AreaStatementLines?$select=Id,MijnCNB_Status&$expand=AreaStatement($select=HarvestYear),
      LicenceContractLine($select=Id),LicenceContractLine($expand=Item($select=Number)),LicenceContractLine($expand=LicenceContract($select=Specie, Cultivar, ModelAgreement)),
      LicenceContractLine($expand=LicenceContract($expand=Licensor($select=Number, Name, MailAddress, MobileNumber))),
      LicenceContractLine($expand=LicenceContract($expand=Licensor($expand=PrimaryAddress($select=Address1, ZipCode, City)))),
      LicenceContractLine($expand=LicenceContract($expand=Licensee($select=Number, Name, MailAddress, MobileNumber))),
      LicenceContractLine($expand=LicenceContract($expand=Licensee($expand=PrimaryAddress($select=Address1, ZipCode, City))))${generateQuery(
        meta,
        null,
        "MijnCNB_Status eq false and AreaStatement/DeletedAt eq null"
      )}`;

      try {
        const { data } = await axios.get(url);
        const payload = _.get(data, "value", []);
        const newMeta = {
          ...meta,
          count: +_.get(data, "odata.count", 0),
        };
        dispatch(success(payload, newMeta));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function request() {
      return { type: actionTypes.GET_AREA_STATEMENT_REQUEST };
    }
    function success(payload, meta) {
      return { type: actionTypes.GET_AREA_STATEMENT_SUCCESS, payload, meta };
    }
    function failure(error) {
      return { type: actionTypes.GET_AREA_STATEMENT_FAILURE, error };
    }
  }

  public static initCreateSpring(
    statementLine: any,
    redirect = false,
    meta: {}
  ) {
    let url = "";
    switch (statementLine.LicenceContractLine.LicenceContract.ModelAgreement) {
      case "BOL-ZANT":
        url = URLS.AREA_STATEMENT_ZANT;
        break;
      case "BOL-LELIE":
        url = URLS.AREA_STATEMENT_LELIE;
        break;
      default:
        url = URLS.AREA_STATEMENT_SPRING;
        break;
    }

    return async (dispatch, getState) => {
      if (_.isEmpty(meta)) {
        meta = _.get(getState(), "areaStatements.meta", {});
      }

      dispatch(success(statementLine, meta));
      dispatch(push(url));
    };

    function success(payload, meta) {
      return {
        type: actionTypes.OPEN_AREA_STATEMENT_PAGE_SUCCESS,
        payload,
        meta,
      };
    }
  }

  public static createZant(statementLine) {
    return async (dispatch) => {
      dispatch(setLoading(true));

      const pdfString = await generateZantPdf(statementLine);

      const fileName = `${statementLine.harvestYear}_${statementLine.cultivar}.pdf`;
      const { status } = await localRequest.post(
        "email/send-area-statement-email",
        {
          language: statementLine.userLanguage,
          email: "tersoo@secondcompany.nl",
          pdfString,
          fileName,
        }
      );
      if (status === 200) {
        downloadDeliveryNote(pdfString, fileName);
      }
      // Upload pdf to CAPI
      await axios.put(
        `AreaStatementLines(${statementLine.Id})/PutPDF`,
        pdfString.split(",")[1],
        {
          headers: {
            "Content-Type": "application/pdf",
          },
        }
      );
      dispatch(setLoading(false));
      dispatch(push(URLS.AREA_STATEMENT_CREATE_URL));
    };
  }

  public static createLelie(statementLine) {
    return async (dispatch) => {
      dispatch(setLoading(true));

      const pdfString = await generateLeliePdf(statementLine);

      const fileName = `${statementLine.harvestYear}_${statementLine.cultivar}.pdf`;
      const { status } = await localRequest.post(
        "email/send-area-statement-email",
        {
          language: statementLine.userLanguage,
          email: "tersoo@secondcompany.nl",
          pdfString,
          fileName,
        }
      );
      if (status === 200) {
        downloadDeliveryNote(pdfString, fileName);
      }
      // Upload pdf to CAPI
      await axios.put(
        `AreaStatementLines(${statementLine.Id})/PutPDF`,
        pdfString.split(",")[1],
        {
          headers: {
            "Content-Type": "application/pdf",
          },
        }
      );
      dispatch(setLoading(false));
      dispatch(push(URLS.AREA_STATEMENT_CREATE_URL));
    };
  }

  public static createSpring(statementLine) {
    return async (dispatch) => {
      dispatch(setLoading(true));

      const pdfString = await generateVorrjPdf(statementLine);

      const fileName = `${statementLine.harvestYear}_${statementLine.cultivar}.pdf`;
      const { status } = await localRequest.post(
        "email/send-area-statement-email",
        {
          language: statementLine.userLanguage,
          email: "tersoo@secondcompany.nl",
          pdfString,
          fileName,
        }
      );
      if (status === 200) {
        downloadDeliveryNote(pdfString, fileName);
      }
      // Upload pdf to CAPI
      await axios.put(
        `AreaStatementLines(${statementLine.Id})/PutPDF`,
        pdfString.split(",")[1],
        {
          headers: {
            "Content-Type": "application/pdf",
          },
        }
      );
      dispatch(setLoading(false));
      dispatch(push(URLS.AREA_STATEMENT_CREATE_URL));
    };
  }
}
